import { render, staticRenderFns } from "./EditPatientInfoModal.vue?vue&type=template&id=2bef1864"
import script from "./EditPatientInfoModal.vue?vue&type=script&lang=js"
export * from "./EditPatientInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports